export enum ReactPortalElementId {
  announcements = 'announcements-portal',
  announcementsAnonUserTracking = 'announcements-anon-user-tracking-portal',
  sementationInsightsToolbarActions = 'segmentation-insights-toolbar-actions',
}
